// src/App.tsx - Updated with Billing Dashboard route
import { QueryClientProvider } from '@tanstack/react-query'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import ProtectedRoute, { AdminRoute, OperatorRoute } from './components/auth/ProtectedRoute'
import { AuthProvider } from './contexts/AuthContext'
import Layout from './Layout'
import { queryClient } from './lib/queryClient'

// Import pages
import Articles from './pages/Articles'
import Categories from './pages/Categories'
import Dashboard from './pages/Dashboard'
import EditArticle from './pages/EditArticle'
import LocationPicker from './pages/LocationPicker'
import Locations from './pages/Locations'
import LogsView from './pages/LogsView'
import QuickAdjust from './pages/QuickAdjust'
import UserManagement from './pages/UserManagement'

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Router
          future={{
            v7_relativeSplatPath: true,
            v7_startTransition: true
          }}
        >
          <ProtectedRoute>
            <Layout>
              <Routes>
                {/* Dashboard - Both Admin and Operator can access */}
                <Route path="/" element={
                  <OperatorRoute>
                    <Dashboard />
                  </OperatorRoute>
                } />

                <Route path="/dashboard" element={
                  <OperatorRoute>
                    <Dashboard />
                  </OperatorRoute>
                } />

                <Route path="/categories" element={
                  <OperatorRoute>
                    <Categories />
                  </OperatorRoute>
                } />

                <Route path="/locations" element={
                  <OperatorRoute>
                    <Locations />
                  </OperatorRoute>
                } />

                <Route path="/logsview" element={
                  <OperatorRoute>
                    <LogsView />
                  </OperatorRoute>
                } />

                <Route path="/articles" element={
                  <OperatorRoute>
                    <Articles />
                  </OperatorRoute>
                } />

                <Route path="/articles/add" element={
                  <OperatorRoute>
                    <EditArticle />
                  </OperatorRoute>
                } />

                <Route path="/articles/edit" element={
                  <OperatorRoute>
                    <EditArticle />
                  </OperatorRoute>
                } />

                {/* User Management - Admin only */}
                <Route path="/users" element={
                  <AdminRoute>
                    <UserManagement />
                  </AdminRoute>
                } />

                <Route path="/articles/quick-adjust" element={
                  <OperatorRoute>
                    <QuickAdjust />
                  </OperatorRoute>
                } />

                <Route path="/location-picker" element={
                  <OperatorRoute>
                    <LocationPicker />
                  </OperatorRoute>
                } />


              </Routes>
            </Layout>
          </ProtectedRoute>
        </Router>
      </AuthProvider>
    </QueryClientProvider>
  )
}

export default App